(function () {
  var SECTION_SELECTOR = "[data-oc-mr-community-creations]";
  var CARD_SELECTOR = "[data-ins-trigger='true']";
  var PROXY_SELECTOR = ".oc-mr-community-creations__instafeed-trigger";
  var INSTAFEED_SOURCE_SELECTOR =
    "[data-instafeed-role-button='true'][data-instafeed-open-id],[data-instafeed-open-id][role='button']";
  var INSTAFEED_RETRY_DELAY = 250;
  var INSTAFEED_RETRY_LIMIT = 8;

  function toInt(value, fallback) {
    var parsed = parseInt(value, 10);
    return Number.isNaN(parsed) ? fallback : parsed;
  }

  function getCards(sectionElement) {
    if (!sectionElement._ocMrCards) {
      sectionElement._ocMrCards = Array.prototype.slice.call(sectionElement.querySelectorAll(CARD_SELECTOR));
    }

    return sectionElement._ocMrCards;
  }

  function clearInstafeedRetry(sectionElement) {
    if (sectionElement._ocMrInstafeedRetryTimer) {
      clearTimeout(sectionElement._ocMrInstafeedRetryTimer);
      delete sectionElement._ocMrInstafeedRetryTimer;
    }
  }

  // Instafeed 的弹窗依赖带有 data-instafeed-open-id 的节点触发。
  // 优先读取当前 section 内隐藏的 app 容器；如果插件渲染在别处，再回退到全页面查找。
  function getInstafeedOpenIds(sectionElement) {
    var host = sectionElement.querySelector(".oc-mr-community-creations__instafeed-host");
    var scope = host || document;

    var hostTriggers = Array.prototype.slice.call(scope.querySelectorAll(INSTAFEED_SOURCE_SELECTOR)).filter(function (
      trigger
    ) {
      // 排除本 section 自己生成的代理层，避免把代理节点再次当作 Instafeed 原始帖子。
      return !trigger.classList.contains("oc-mr-community-creations__instafeed-trigger");
    });

    if (hostTriggers.length) {
      sectionElement._ocMrInstafeedOpenIds = hostTriggers.reduce(function (openIds, trigger) {
        var openId = trigger.getAttribute("data-instafeed-open-id");

        if (openId && openIds.indexOf(openId) === -1) {
          openIds.push(openId);
        }

        return openIds;
      }, []);
    }

    return sectionElement._ocMrInstafeedOpenIds || [];
  }

  function getCardInstafeedProxy(card) {
    return card.querySelector(PROXY_SELECTOR);
  }

  // 在自定义卡片上生成透明代理触发层，而不是直接搬动 Instafeed 自己的 DOM。
  // 映射规则按可见顺序对应：第 1 张卡片 -> 第 1 条帖子，第 2 张卡片 -> 第 2 条帖子。
  function attachInstafeedTriggers(sectionElement) {
    var cards = getCards(sectionElement);
    var openIds = getInstafeedOpenIds(sectionElement);
    var attachedCount = 0;

    if (!cards.length || !openIds.length) {
      return attachedCount;
    }

    cards.forEach(function (card) {
      var index = toInt(card.dataset.insIndex, -1);
      var openId = openIds[index];
      var existingProxy = getCardInstafeedProxy(card);

      if (!openId) {
        if (existingProxy) {
          existingProxy.remove();
        }
        return;
      }

      if (existingProxy && existingProxy.getAttribute("data-instafeed-open-id") === openId) {
        attachedCount += 1;
        return;
      }

      if (existingProxy) {
        existingProxy.remove();
      }

      var proxy = document.createElement("div");
      proxy.className = "oc-mr-community-creations__instafeed-trigger";
      proxy.setAttribute("data-instafeed-open-id", openId);
      proxy.setAttribute("data-instafeed-role-button", "true");
      proxy.setAttribute("aria-haspopup", "dialog");
      proxy.setAttribute("aria-label", "Instagram post opens in a popup");
      proxy.setAttribute("role", "button");
      proxy.setAttribute("tabindex", "-1");

      card.appendChild(proxy);
      attachedCount += 1;
    });

    return attachedCount;
  }

  // Instafeed 可能异步渲染，因此通过防抖统一处理 load、事件通知和 DOM 变化后的重新绑定。
  function scheduleInstafeedTriggerAttach(sectionElement, remainingRetries) {
    if (sectionElement._ocMrInstafeedAttachTimer) {
      clearTimeout(sectionElement._ocMrInstafeedAttachTimer);
    }

    sectionElement._ocMrInstafeedAttachTimer = window.setTimeout(function () {
      var attachedCount = attachInstafeedTriggers(sectionElement);

      if (attachedCount || remainingRetries <= 0) {
        clearInstafeedRetry(sectionElement);
        return;
      }

      clearInstafeedRetry(sectionElement);
      sectionElement._ocMrInstafeedRetryTimer = window.setTimeout(function () {
        scheduleInstafeedTriggerAttach(sectionElement, remainingRetries - 1);
      }, INSTAFEED_RETRY_DELAY);
    }, 120);
  }

  function initInstafeedTriggerBridge(sectionElement) {
    if (sectionElement.dataset.ocMrInstafeedBridgeInit === "true") {
      return;
    }

    sectionElement.dataset.ocMrInstafeedBridgeInit = "true";
    scheduleInstafeedTriggerAttach(sectionElement, INSTAFEED_RETRY_LIMIT);

    sectionElement._ocMrInstafeedLoadedHandler = function () {
      scheduleInstafeedTriggerAttach(sectionElement, INSTAFEED_RETRY_LIMIT);
    };
    document.addEventListener("instafeedAppLoaded", sectionElement._ocMrInstafeedLoadedHandler);
    window.addEventListener("load", sectionElement._ocMrInstafeedLoadedHandler);

    if (typeof MutationObserver !== "undefined") {
      var host = sectionElement.querySelector(".oc-mr-community-creations__instafeed-host");

      if (!host) {
        return;
      }

      sectionElement._ocMrInstafeedObserver = new MutationObserver(function () {
        scheduleInstafeedTriggerAttach(sectionElement, 2);
      });
      sectionElement._ocMrInstafeedObserver.observe(host, {
        childList: true,
        subtree: true,
      });
    }
  }

  // 点击卡片时优先尝试打开 Instafeed 弹窗；如果代理层还没挂上，先补绑一次再决定是否兜底。
  function openInstafeedPopupByIndex(sectionElement, index) {
    if (index < 0) {
      return false;
    }

    var cards = getCards(sectionElement);
    var card = cards[index];
    var target = card ? getCardInstafeedProxy(card) : null;

    if (!target) {
      attachInstafeedTriggers(sectionElement);
      target = card ? getCardInstafeedProxy(card) : null;
    }

    if (!target) {
      return false;
    }

    target.click();
    return true;
  }

  function handleCardActivate(sectionElement, card, event) {
    if (event.target.closest(PROXY_SELECTOR)) {
      return;
    }

    var instafeedIndex = toInt(card.dataset.insIndex, -1);
    var detail = {
      url: card.dataset.insUrl || "",
      instafeedIndex: instafeedIndex,
      username: card.dataset.insUsername || "",
      image: card.dataset.insImage || "",
      sectionId: card.dataset.sectionId || "",
      blockId: card.dataset.blockId || "",
    };

    var popupEvent = new CustomEvent("oc:ins-popup:open", {
      bubbles: true,
      cancelable: true,
      detail: detail,
    });

    var shouldContinue = card.dispatchEvent(popupEvent);

    if (!shouldContinue) {
      event.preventDefault();
      return;
    }

    if (openInstafeedPopupByIndex(sectionElement, instafeedIndex)) {
      event.preventDefault();
      return;
    }

    // 插件未加载或找不到对应帖子时，才使用运营可配置的 fallback URL 兜底。
    if (!detail.url) {
      event.preventDefault();
    }

    if (card.tagName !== "A" && detail.url) {
      window.open(detail.url, "_blank", "noopener");
    }
  }

  function bindInsEvent(sectionElement) {
    sectionElement._ocMrCardClickHandler = function (event) {
      var card = event.target.closest(CARD_SELECTOR);

      if (!card || !sectionElement.contains(card)) {
        return;
      }

      handleCardActivate(sectionElement, card, event);
    };

    sectionElement._ocMrCardKeydownHandler = function (event) {
      if (event.key !== "Enter" && event.key !== " ") {
        return;
      }

      var card = event.target.closest(CARD_SELECTOR);

      if (!card || !sectionElement.contains(card) || card.tagName === "A") {
        return;
      }

      event.preventDefault();
      handleCardActivate(sectionElement, card, event);
    };

    sectionElement.addEventListener("click", sectionElement._ocMrCardClickHandler);
    sectionElement.addEventListener("keydown", sectionElement._ocMrCardKeydownHandler);
  }

  function initInteractions(sectionElement) {
    if (sectionElement.dataset.ocMrCommunityCreationsEventsInit === "true") {
      return;
    }

    initInstafeedTriggerBridge(sectionElement);
    bindInsEvent(sectionElement);
    sectionElement.dataset.ocMrCommunityCreationsEventsInit = "true";
  }

  function initSwiper(sectionElement) {
    if (sectionElement.dataset.ocMrCommunityCreationsInit === "true") {
      return true;
    }

    var swiperElement = sectionElement.querySelector("[data-card-swiper]");
    if (!swiperElement || typeof Swiper === "undefined") {
      return false;
    }

    var slideCount = toInt(sectionElement.dataset.slideCount, 0);
    var showDesktopNav = slideCount > 4;

    var nextButton = sectionElement.querySelector("[data-nav-next]");
    var prevButton = sectionElement.querySelector("[data-nav-prev]");

    var swiper = new Swiper(swiperElement, {
      slidesPerView: "auto",
      slidesPerGroup: 1,
      loop: false,
      speed: 450,
      watchOverflow: true,
      observer: true,
      observeParents: true,
      allowTouchMove: slideCount > 1,
      navigation: showDesktopNav
        ? {
            nextEl: nextButton,
            prevEl: prevButton,
          }
        : undefined,
      breakpoints: {
        0: {
          spaceBetween: 10,
          allowTouchMove: slideCount > 1,
        },
        769: {
          spaceBetween: 20,
          allowTouchMove: showDesktopNav,
        },
      },
    });

    sectionElement._ocMrCommunityCreationsSwiper = swiper;
    sectionElement.dataset.ocMrCommunityCreationsInit = "true";

    return true;
  }

  function initSection(sectionElement) {
    initInteractions(sectionElement);

    // 交互绑定不能依赖 Swiper 初始化时机；如果 Swiper 晚于 section 渲染，再补一次初始化。
    if (!initSwiper(sectionElement)) {
      window.setTimeout(function () {
        initSwiper(sectionElement);
      }, 300);
    }
  }

  function destroySection(sectionElement) {
    if (sectionElement && sectionElement._ocMrCommunityCreationsSwiper) {
      sectionElement._ocMrCommunityCreationsSwiper.destroy(true, true);
      delete sectionElement._ocMrCommunityCreationsSwiper;
      delete sectionElement.dataset.ocMrCommunityCreationsInit;
    }

    if (sectionElement && sectionElement._ocMrInstafeedObserver) {
      sectionElement._ocMrInstafeedObserver.disconnect();
      delete sectionElement._ocMrInstafeedObserver;
    }

    if (sectionElement && sectionElement._ocMrInstafeedLoadedHandler) {
      document.removeEventListener("instafeedAppLoaded", sectionElement._ocMrInstafeedLoadedHandler);
      window.removeEventListener("load", sectionElement._ocMrInstafeedLoadedHandler);
      delete sectionElement._ocMrInstafeedLoadedHandler;
    }

    if (sectionElement && sectionElement._ocMrInstafeedAttachTimer) {
      clearTimeout(sectionElement._ocMrInstafeedAttachTimer);
      delete sectionElement._ocMrInstafeedAttachTimer;
    }

    if (sectionElement && sectionElement._ocMrInstafeedRetryTimer) {
      clearTimeout(sectionElement._ocMrInstafeedRetryTimer);
      delete sectionElement._ocMrInstafeedRetryTimer;
    }

    if (sectionElement && sectionElement._ocMrCardClickHandler) {
      sectionElement.removeEventListener("click", sectionElement._ocMrCardClickHandler);
      delete sectionElement._ocMrCardClickHandler;
    }

    if (sectionElement && sectionElement._ocMrCardKeydownHandler) {
      sectionElement.removeEventListener("keydown", sectionElement._ocMrCardKeydownHandler);
      delete sectionElement._ocMrCardKeydownHandler;
    }

    if (sectionElement) {
      delete sectionElement._ocMrCards;
      delete sectionElement._ocMrInstafeedOpenIds;
      delete sectionElement.dataset.ocMrInstafeedBridgeInit;
      delete sectionElement.dataset.ocMrCommunityCreationsEventsInit;
    }
  }

  function initAll(root) {
    var scope = root || document;
    scope.querySelectorAll(SECTION_SELECTOR).forEach(initSection);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      initAll(document);
    });
  } else {
    initAll(document);
  }

  // 兼容 Shopify Theme Editor 中的 section 重载，避免商家调整 block 或 app 设置后事件残留。
  document.addEventListener("shopify:section:load", function (event) {
    initAll(event.target);
  });

  document.addEventListener("shopify:section:unload", function (event) {
    var sectionElement = event.target.querySelector(SECTION_SELECTOR);
    destroySection(sectionElement);
  });
})();
